import type {
  FrontendAssortmentDimensionAttributeAggregation,
  GetInSeasonAggregationsListRequestBody,
} from '../types';

import { transformDimensionAttributes } from './transform-dimensions';

type RequestBody = Omit<
  GetInSeasonAggregationsListRequestBody,
  'dimensions'
> & {
  dimensions: FrontendAssortmentDimensionAttributeAggregation;
};

export const transformInSeasonAggregationRequest = (
  body: RequestBody,
): GetInSeasonAggregationsListRequestBody => {
  const { dimensions, ...rest } = body;
  const transformedDimensions = transformDimensionAttributes(dimensions);
  return {
    ...rest,
    dimensions: transformedDimensions,
  };
};
